import Vue from 'vue';

export const notify = (
  type = 'error',
  title,
  text,
  group = 'foo',
  duration = 5000
) => {
  Vue.notify({
    group: group,
    title: title,
    type: type,
    text: text,
    duration: duration
  });
};

export const setKeyNameLS = (state) => {
  const { contract_id, event_code } = state.checkEvent;
  if (contract_id !== null && event_code !== null) {
    return contract_id + event_code;
  }
  return null;
};

export const getEventFromLS = (state) => {
  const keyNameLS = setKeyNameLS(state);

  const obj =
    localStorage.getItem(keyNameLS) !== null
      ? JSON.parse(localStorage.getItem(keyNameLS))
      : null;

  if (obj !== null) {
    const event = obj.event;
    return event;
  }
};

export const getObjFromLS = (state) => {
  const keyNameLS = setKeyNameLS(state);

  const obj =
    localStorage.getItem(keyNameLS) !== null
      ? JSON.parse(localStorage.getItem(keyNameLS))
      : null;

  if (obj !== null) {
    return obj;
  }
};
